import { z } from 'zod';
import { issue, msg } from '@/lib/forms/messages';
import { boundedText } from '@/lib/forms/primitives';

// Mirrors api/routes/cad.py:230-232 (ge=0), domain/cad/thickness_models.py:142-146
// (finite; lower_mm <= upper_mm domain-only). z.number: useThicknessConfig submits numbers as-is.
// Not form fields, so no rules here: clusterRadiusMm/clusterMinPoints, profile.
const conditionMm = z
  .number(msg('cad.thickness.config.invalidNumber'))
  .finite(msg('cad.thickness.config.invalidNumber'))
  .min(0, msg('cad.thickness.config.invalidNumber'));

export const thicknessConditionsSchema = z
  .object({
    lowerMm: conditionMm,
    upperMm: conditionMm,
    toleranceMm: conditionMm,
  })
  .superRefine((value, ctx) => {
    if (value.lowerMm > value.upperMm) {
      ctx.addIssue(issue('cad.thickness.config.invalidRange', ['lowerMm']));
    }
  });

// Mirrors api/routes/cad.py:329 (min_length=1, max_length=120). savePreset submits the
// trimmed name (no raw/trimmed gap); the 120 cap is a labelled client-side delta.
export const thicknessPresetNameSchema = boundedText(
  120,
  'cad.thickness.preset.nameRequired',
  'validation.maxLength',
);
